import { faAngleLeft as faAngleLeftSolid } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import { faAngleRight as faAngleRightSolid } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faAt as faAtSolid } from '@fortawesome/pro-solid-svg-icons/faAt'
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog'
import { faCommentSlash } from '@fortawesome/pro-solid-svg-icons/faCommentSlash'
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH'
import { faEllipsisV as fasEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { faExternalLinkSquare } from '@fortawesome/pro-solid-svg-icons/faExternalLinkSquare'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faMagic } from '@fortawesome/pro-solid-svg-icons/faMagic'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply'
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons/faSpinnerThird'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'

const solidIcons = [
  faAngleLeftSolid,
  faAngleRightSolid,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faAtSolid,
  faBolt,
  faCheck,
  faCheckCircle,
  faCommentSlash,
  faCog,
  faEllipsisH,
  fasEllipsisV,
  faEye,
  faEyeSlash,
  faInfoCircle,
  faExternalLinkSquare,
  faMagic,
  faPaperPlane,
  faPause,
  faPlay,
  faReply,
  faSpinnerThird,
  faStar,
  faTimesCircle,
  faTrash
]

export default solidIcons
